//React Components and Hooks
import {
  CircularProgress as MuiCircularProgress,
  Divider as MuiDivider,
  Box,
  Paper,
  Button,
  Typography as MuiTypography,
} from "@mui/material";
//Material UI Components and Functions
import { makeStyles } from "@mui/styles";
import { withStyles } from "@mui/styles";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem as MuiTimelineItem,
  TimelineSeparator,
} from "@mui/lab";
import Skeleton from "@mui/material/Skeleton";
import { spacing } from "@mui/system";
// Redux Components
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
import moment from "moment";
// Custom application component imports:
import { LeftSidebar as NavFrame } from "layout-blueprints"; // The top navigation bar and side navigation panel
import {
  getAllGlCodes,
  getAllPropertyPreviews,
  getAnalyticalData,
} from "../../modules/apl/api/actions";
import { get as getVendors } from "../../modules/vendor/api/actions";
import {
  deleteBillDraftByUUID,
  getAllUnsettledPropertyMeterReadingsByPropertyUUID,
  getBillInProgressDraft,
  getSelectedBillWizPropertyInfoByPropUUID,
  handleBillingProcessSubmission,
  updateBillingWizardBillInProgress,
  updateBillingWizardSelectedProperty,
} from "../../modules/billing/api/actions";
import { setSnackbar } from "../../modules/snackbar/api/snackbar";
import CustomBillWizardFormProcessingSnackbar from "../../modules/snackbar/components/billingWizardFormTransitionSnackbar";
import CustomErrorSnackbar from "../../modules/snackbar/components/customErrorSnackbar";
import { logout } from "../../modules/user/api/actions";
import BillingInformationForm from "./Components/Forms/BillingInformation";
import FinalizeForm from "./Components/Forms/Finalize";
import PropertyMeterDataForm from "./Components/Forms/MeterReadCheck";
import TrialBillingForm from "./Components/Forms/TrialBilling";
import TrialBillingSummaryForm from "./Components/Forms/TrialBillingSummary";
import VendorInformationForm from "./Components/Forms/VendorInformation";
import ToolBar from "./ToolBar";

function BillingWizardPhase(Title, Content) {
  return {
    title: Title,
    content: Content,
  };
}

const Divider = styled(MuiDivider)(spacing);
const Typography = styled(MuiTypography)(spacing);
const CircularProgress = styled(MuiCircularProgress)(spacing);

const TimelineItem = withStyles({
  missingOppositeContent: {
    "&:before": {
      display: "none",
    },
  },
})(MuiTimelineItem);

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  percentDif: {
    textAlign: "right",
    color: "green",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  loadingIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  billingWizardContent: {
    maxHeight: "60%",
  },
  paper: {
    // Responsive padding now handled by sx prop
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  formLoadingSkeleton: {
    height: "300px",
    backgroundColor: `#bdbfbe`,
    padding: 6,
    margin: 6,
    marginBottom: 3,
  },
  snackbarRoot: {
    maxWidth: 600,
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  documentToolBar: {
    padding: 60,
  },
}));

const BillingWizard = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [isDeleting, setIsDeleting] = React.useState(false);
  const navTo = (page) => navigate(page);
  const logout = () => {
    props.logout();
    props.navigate("/");
  };

  const RefreshPage = async () => {
    props.getAllPropertyPreviews();
    props.getAllGlCodes();
    props.getVendors();
    if (params.wtUuid != "new") {
      props.getBillInProgressDraft(params.wtUuid);
    }
  };

  const updateCurrentBillingObjAndRunTrialBillsGeneration = () => {
    props.billing.data.billInProgress.currentStep = 3; // Sets the state to the next phase before saving
    props.billing.data.billInProgress.generateTrialBilling = true;
    props.updateBillingWizardBillInProgress(props.billing.data.billInProgress);
    props.handleBillingProcessSubmission(props.billing.data.billInProgress);
  };

  const handleNext = () => {
    props.billing.data.billInProgress.currentStep = props.billing.data.billInProgress.currentStep + 1;
    props.handleBillingProcessSubmission(props.billing.data.billInProgress, false)
  }
  const handleSave = () => {
    props.handleBillingProcessSubmission(props.billing.data.billInProgress, true);
  }

  const DeleteBillingDraftAndCloseTab = () => {
    console.log("DeleteBillingDraftAndCloseTab");
    if (params.wtUuid != "new") {
      console.log("Saved Bill Deleting Draft");
      props.deleteBillDraftByUUID(params.wtUuid);
    } else {
      console.log("New Bill, Closing Window");
      setIsDeleting(true);
    }
  };

  // On initial page load methods:
  useEffect(() => {
    RefreshPage();
  }, []);

  /*
  if (props.billing.data.billInProgress.errors.length > 0){
    dispatch(setSnackbar(true, "error", "Test Message"));
  }*/
  var pageTitle = "Ubil+ Billing Draft";
  // Sets the tab name based on the loaded account being worked on
  if (
    params.wtUuid == "new" &&
    (!props.billing.data.selectedProperty || !props.billing.data.selectedProperty.id)
  ) {
    pageTitle = "Ubil+ New Billing Draft";
  } else if (props.billing.data.selectedProperty && props.billing.data.selectedProperty.id) {
    pageTitle = "New Billing: " + props.billing.data.selectedProperty.name;

  }
  document.title = pageTitle;
  if (props.billing.billIsBeingDeleted || isDeleting) {
    navTo("/billingdashboard/4000");
  }
  if (props.billing.data.billInProgress.successfulTrialBillExecutionAttempt) {
    navTo("/billingdashboard/4000");
  }
  if (
    params.wtUuid == "new" &&
    props.billing.data.billInProgress.accountBillWorkTableUUID != -1
  ) {
    navTo(
      "/billingwizard/" +
      props.billing.data.billInProgress.accountBillWorkTableUUID
    );
  }
  // Clause to goto the process page if bill has already been submitted
  if (!props.billing.billInProgressIsLoading &&
    props.billing.data.billInProgress.existingBillingBatchSet != null &&
    props.billing.data.billInProgress.existingBillingBatchSet.fulfillmentValue &&
    props.billing.data.billInProgress.existingBillingBatchSet.fulfillmentValue.id) {
    navTo("/batches/" + props.billing.data.billInProgress.existingBillingBatchSet.fulfillmentValue.id);
  }
  const phase = props.billing.data.billInProgress.currentStep;
  let isProcessingCurrently =
    props.billing.isLoading ||
    props.billing.billInProgressIsLoading ||
    props.billing.selectedPropertyMetersAreLoading ||
    props.billing.selectedPropertyIsLoading;
  var message = "Billing Process Assets Loaded Successfully";
  var severity = "success";

  if (props.billing.isLoading) {
    message = "Getting progress on current billing process....";
  }
  if (props.billing.selectedPropertyIsLoading) {
    message = "Getting Bill's selected property...";
    severity = "warning";
  }
  if (props.billing.selectedPropertyMetersAreLoading) {
    message = "Getting Selected property's meter data...";
    severity = "warning";
  }
  if (props.billing.billInProgressIsLoading) {
    message = "Processing Bill In Progress...";
    severity = "warning";
  }
  if (
    !isProcessingCurrently &&
    props.billing.error != "" &&
    props.billing.error != null
  ) {
    severity = "error";
    message = "Error! Unable to retrieve property billing/ property meter data";
  } else if (isProcessingCurrently) {
    severity = "warning";
  }

  if (props.billing.billIsBeingSubmittedbillIsBeingSubmitted) {
    isProcessingCurrently = true;
    message = "Saving, Validating, and Submitting Bill In Progress...";
    severity = "warning";
  }

  if (
    params.wtUuid == "new" &&
    (!props.billing.data.selectedProperty || !props.billing.data.selectedProperty.id)
  ) {
    props.billing.isLoading = false;
    props.billing.billInProgressIsLoading = false;
    props.billing.selectedPropertyMetersAreLoading = false;
    props.billing.selectedPropertyIsLoading = false;
    message = null;
    severity = null;
  }
  var currentPath = "Billing  /  Billing Wizard"
  if (!props.billing.billInProgressIsLoading) {
    currentPath = currentPath + `  -   Created: ${props.billing.data.billInProgress.createdDate || moment().format("MM/DD/YYYY")}`
  }
  // On Data Loaded:
  return (
    <NavFrame page={"BillingWizard"}>
      <StandardHeader
        title={pageTitle}
        rightSideToolBar={
          <ToolBar
            refreshPage={RefreshPage}
            deleteDraft={DeleteBillingDraftAndCloseTab}
            regenerateTrialBillItems={
              updateCurrentBillingObjAndRunTrialBillsGeneration
            }
          />
        }
        appPath={currentPath}
      />
      <Divider className="mb-3 mt-3" />
      <CustomBillWizardFormProcessingSnackbar
        message={message}
        severity={severity}
        isProcessingForm={isProcessingCurrently}
      />
      <CustomErrorSnackbar
        errors={props.billing.data.billInProgress.errors}
        refreshPage={RefreshPage}
        isLoading={props.billing.isLoading}
      />
      <Paper
        elevation={1}
        className={classes.paper}
        sx={{
          padding: { xs: 1, sm: 2, md: 3 },
          paddingLeft: { xs: 1, sm: 2, md: 2 },
          margin: 0,
          marginLeft: 0,
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        {/*<RightAlignedTimeline Phases={applicationPhases} CurrentPhase={props.billing.data.billInProgress.currentStep}/>*/}
        {props.billing.billInProgressIsLoading &&
          props.billing.data.billInProgress.accountBillWorkTableUUID == -1 ? (
          <>
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: '100%'
            }}>
              <Box sx={{ width: '100%' }}>
                <Skeleton
                  variant="rect"
                  className={classes.formLoadingSkeleton}
                />
              </Box>
              <Box sx={{ width: '100%' }}>
                <Skeleton
                  variant="rect"
                  className={classes.formLoadingSkeleton}
                />
              </Box>
              <Box sx={{ width: '100%' }}>
                <Skeleton
                  variant="rect"
                  className={classes.formLoadingSkeleton}
                />
              </Box>
            </Box>
          </>
        ) : (
          <Box sx={{
            width: '100%',
            '& .MuiTimeline-root': {
              padding: 0,
              margin: 0,
              width: '100%',
              paddingLeft: '0 !important',
            },
            '& .MuiTimelineItem-root': {
              minHeight: { xs: 'auto', sm: '70px' },
              paddingLeft: '0 !important',
              marginLeft: 0,
              '&:before': {
                display: 'none !important',
              },
            },
            '& .MuiTimelineContent-root': {
              padding: '0 !important',
              paddingLeft: '0 !important',
              marginLeft: '0 !important',
              marginBottom: { xs: 2, sm: 0 },
              flex: 1,
            },
            '& .MuiTimelineSeparator-root': {
              marginRight: { xs: 2, sm: 3 },
            },
            '& .MuiTimelineDot-root': {
              width: { xs: 32, sm: 40 },
              height: { xs: 32, sm: 40 },
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
            },
          }}>
            <Timeline sx={{
              width: '100%',
              margin: 0,
              padding: 0,
              paddingLeft: '0 !important',
              marginLeft: 0,
              '& .MuiTimeline-root': {
                paddingLeft: 0
              }
            }}>
              <TimelineItem
                id={"tlItem"}
                color="secondary"
                sx={{
                  paddingLeft: '0 !important',
                  marginLeft: 0,
                  '&:before': { display: 'none !important' }
                }}
              >
                <TimelineSeparator id={"tlSeperator"}>
                  <TimelineDot color={phase >= 0 ? "secondary" : "primary"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                      #1
                    </Box>
                  </TimelineDot>
                  <TimelineConnector
                    className={phase >= 0 && classes.secondaryTail}
                  />
                </TimelineSeparator>

                <TimelineContent id={"tlContent"}>
                  <Typography
                    variant="h6"
                    className={classes.openPhaseTitle}
                    color={phase >= 0 ? "secondary" : "primary"}
                    sx={{
                      fontSize: { xs: '1.1rem', sm: '1.25rem' },
                      marginBottom: { xs: 1, sm: 2 },
                    }}
                  >
                    Billing Information
                  </Typography>
                  {/* The phase card content go here */}
                  {phase >= 0 && (
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      width: '100%',
                      mt: 2,
                      alignItems: 'flex-start'
                    }}>
                      <Box sx={{ width: '100%' }}>
                        <BillingInformationForm />
                      </Box>
                      {phase == 0 && (
                        <Box sx={{
                          display: 'flex',
                          justifyContent: { xs: 'center', sm: 'flex-start' },
                          flexDirection: { xs: 'column', sm: 'row' },
                          gap: { xs: 1, sm: 2 },
                          mt: 2,
                          width: '100%'
                        }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            sx={{
                              minWidth: 'auto',
                              fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                              padding: { xs: '12px 16px', sm: '8px 22px' }
                            }}
                          >
                            Save and Continue
                          </Button>
                        </Box>
                      )}
                    </Box>
                  )}
                </TimelineContent>
              </TimelineItem>

              <TimelineItem
                id={"tlItem"}
                color="secondary"
                sx={{
                  paddingLeft: '0 !important',
                  marginLeft: 0,
                  '&:before': { display: 'none !important' }
                }}
              >
                <TimelineSeparator id={"tlSeperator"}>
                  <TimelineDot color={phase >= 1 ? "secondary" : "primary"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                      #2
                    </Box>
                  </TimelineDot>
                  <TimelineConnector className={classes.secondaryTail} />
                </TimelineSeparator>
                <TimelineContent id={"tlContent"}>
                  <Typography
                    variant="h6"
                    className={classes.openPhaseTitle}
                    color={phase >= 1 ? "secondary" : "primary"}
                    sx={{
                      fontSize: { xs: '1.1rem', sm: '1.25rem' },
                      marginBottom: { xs: 1, sm: 2 },
                    }}
                  >
                    Vendor Information
                  </Typography>
                  {/* The phase card content go here */}
                  {phase >= 1 && (
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      width: '100%',
                      mt: 2,
                      alignItems: 'flex-start'
                    }}>
                      <Box sx={{ width: '100%' }}>
                        <VendorInformationForm />
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 1, sm: 2 },
                        mt: 2,
                        width: '100%'
                      }}>
                        {phase == 1 && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                            sx={{
                              minWidth: 'auto',
                              fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                              padding: { xs: '12px 16px', sm: '8px 22px' }
                            }}
                          >
                            Save and Continue
                          </Button>
                        )}
                        {phase > 1 && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSave}
                            sx={{
                              minWidth: 'auto',
                              fontSize: { xs: '0.875rem', sm: '0.9375rem' },
                              padding: { xs: '12px 16px', sm: '8px 22px' }
                            }}
                          >
                            Save
                          </Button>
                        )}
                      </Box>
                    </Box>
                  )}
                </TimelineContent>
              </TimelineItem>

              <TimelineItem
                id={"tlItem"}
                color="secondary"
                sx={{
                  paddingLeft: '0 !important',
                  marginLeft: 0,
                  '&:before': { display: 'none !important' }
                }}
              >
                <TimelineSeparator id={"tlSeperator"}>
                  <TimelineDot color={phase >= 2 ? "secondary" : "primary"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                      #3
                    </Box>
                  </TimelineDot>
                  {phase >= 2 ? (
                    <TimelineConnector className={classes.secondaryTail} />
                  ) : (
                    <TimelineConnector />
                  )}
                </TimelineSeparator>
                <TimelineContent id={"tlContent"} sx={{ mt: 2 }}>
                  <Typography
                    variant="h6"
                    className={classes.openPhaseTitle}
                    color={phase >= 2 ? "secondary" : "primary"}
                    sx={{
                      fontSize: { xs: '1.1rem', sm: '1.25rem' },
                      marginBottom: { xs: 1, sm: 2 },
                    }}
                  >
                    Meter Read Check
                  </Typography>
                  {/* The phase card content go here */}
                  {phase >= 2 && (
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      width: '100%',
                      mt: 2,
                      alignItems: 'flex-start'
                    }}>
                      <Box sx={{ width: '100%' }}>
                        <PropertyMeterDataForm />
                      </Box>
                    </Box>
                  )}
                </TimelineContent>
              </TimelineItem>

              <TimelineItem
                id={"tlItem"}
                color="secondary"
                sx={{
                  paddingLeft: '0 !important',
                  marginLeft: 0,
                  '&:before': { display: 'none !important' }
                }}
              >
                <TimelineSeparator id={"tlSeperator"}>
                  <TimelineDot color={phase >= 3 ? "secondary" : "primary"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                      #4
                    </Box>
                  </TimelineDot>
                  {phase >= 3 ? (
                    <TimelineConnector className={classes.secondaryTail} />
                  ) : (
                    <TimelineConnector />
                  )}
                </TimelineSeparator>
                <TimelineContent id={"tlContent"}>
                  <Typography
                    variant="h6"
                    className={classes.openPhaseTitle}
                    color={phase >= 3 ? "secondary" : "primary"}
                    sx={{
                      fontSize: { xs: '1.1rem', sm: '1.25rem' },
                      marginBottom: { xs: 1, sm: 2 },
                    }}
                  >
                    Trial Billing
                  </Typography>
                  {/* The phase card content go here */}
                  {phase >= 3 && (
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      width: '100%',
                      mt: 2,
                      alignItems: 'flex-start'
                    }}>
                      <Box sx={{ width: '100%' }}>
                        <TrialBillingForm />
                      </Box>
                    </Box>
                  )}
                </TimelineContent>
              </TimelineItem>

              <TimelineItem
                id={"tlItem"}
                color="secondary"
                sx={{
                  paddingLeft: '0 !important',
                  marginLeft: 0,
                  '&:before': { display: 'none !important' }
                }}
              >
                <TimelineSeparator id={"tlSeperator"}>
                  <TimelineDot color={phase >= 3 ? "secondary" : "primary"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                      #5
                    </Box>
                  </TimelineDot>
                  {phase >= 3 ? (
                    <TimelineConnector className={classes.secondaryTail} />
                  ) : (
                    <TimelineConnector />
                  )}
                </TimelineSeparator>
                <TimelineContent id={"tlContent"}>
                  <Typography
                    variant="h6"
                    className={classes.openPhaseTitle}
                    color={phase >= 4 ? "secondary" : "primary"}
                    sx={{
                      fontSize: { xs: '1.1rem', sm: '1.25rem' },
                      marginBottom: { xs: 1, sm: 2 },
                    }}
                  >
                    Trial Billing Summary
                  </Typography>
                  {/* The phase card content go here */}
                  {phase >= 3 && (
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      width: '100%',
                      mt: 2,
                      alignItems: 'flex-start'
                    }}>
                      <Box sx={{ width: '100%' }}>
                        <TrialBillingSummaryForm />
                      </Box>
                    </Box>
                  )}
                </TimelineContent>
              </TimelineItem>

              <TimelineItem
                id={"tlItem"}
                color="secondary"
                sx={{
                  paddingLeft: '0 !important',
                  marginLeft: 0,
                  '&:before': { display: 'none !important' }
                }}
              >
                <TimelineSeparator id={"tlSeperator"}>
                  <TimelineDot color={phase >= 3 ? "secondary" : "primary"}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                      #6
                    </Box>
                  </TimelineDot>
                  {phase >= 4 && (
                    <TimelineConnector className={classes.secondaryTail} />
                  )}
                </TimelineSeparator>
                <TimelineContent id={"tlContent"}>
                  <Typography
                    variant="h6"
                    className={classes.openPhaseTitle}
                    color={phase >= 4 ? "secondary" : "primary"}
                    sx={{
                      fontSize: { xs: '1.1rem', sm: '1.25rem' },
                      marginBottom: { xs: 1, sm: 2 },
                    }}
                  >
                    Finalize
                  </Typography>
                  {/* The phase card content go here */}
                  {phase >= 3 && (
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      width: '100%',
                      mt: 2,
                      alignItems: 'flex-start'
                    }}>
                      <Box sx={{ width: '100%' }}>
                        <FinalizeForm />
                      </Box>
                    </Box>
                  )}
                </TimelineContent>
              </TimelineItem>
            </Timeline>
          </Box>
        )}
      </Paper>
      {/*
        <Snackbar
            className={classes.documentToolBar}
            open={true}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <ToolBar refreshPage={RefreshPage} deleteDraft={DeleteBillingDraftAndCloseTab} regenerateTrialBillItems={updateCurrentBillingObjAndRunTrialBillsGeneration}/>
        </Snackbar>
        */}
    </NavFrame>
  );
};

// Component Properties
BillingWizard.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  // Store object functions:
  logout: PropTypes.func.isRequired,
  getAllPropertyPreviews: PropTypes.func.isRequired,
  updateBillingWizardSelectedProperty: PropTypes.func.isRequired,
  updateBillingWizardBillInProgress: PropTypes.func.isRequired,
  getAllUnsettledPropertyMeterReadingsByPropertyUUID: PropTypes.func.isRequired,
  getAllGlCodes: PropTypes.func.isRequired,
  getBillInProgressDraft: PropTypes.func.isRequired,
  getSelectedBillWizPropertyInfoByPropUUID: PropTypes.func.isRequired,
  getVendors: PropTypes.func.isRequired,
  setSnackbar: PropTypes.func.isRequired,
  deleteBillDraftByUUID: PropTypes.func.isRequired,
  handleBillingProcessSubmission: PropTypes.func.isRequired,
};
// Component State
function BillingWizardPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    billing: state.billing,
  };
}
export default connect(BillingWizardPageState, {
  handleBillingProcessSubmission,
  logout,
  getAnalyticalData,
  getAllGlCodes,
  getBillInProgressDraft,
  getAllPropertyPreviews,
  setSnackbar,
  getAllUnsettledPropertyMeterReadingsByPropertyUUID,
  getSelectedBillWizPropertyInfoByPropUUID,
  updateBillingWizardSelectedProperty,
  updateBillingWizardBillInProgress,
  getVendors,
  deleteBillDraftByUUID,
})(BillingWizard);
